import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { IconButton } from '@gto/ui/icon-button'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

import { ArrowRightIcon } from '@/assets/icons'
import { useSupportLinks } from '@/components/support-links'

export const PersonalPropositionBanner = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')
  const supportLinks = useSupportLinks()

  return (
    <Paper
      as="aside"
      className="rounded-md border border-divider px-16 py-4 md:px-8 sm:px-4 sm:py-3"
      elevation="1"
    >
      <div className="flex items-center gap-6 md:flex-col md:gap-4">
        <div className="flex-1 text-left md:text-center">
          <Typography
            gutterBottom
            className="text-[24px] font-semibold sm:text-[20px]"
            color="primary"
            variant="h5"
          >
            <FormattedMessage id="home.contactUs.title" />
          </Typography>
        </div>
        <div className="flex-none md:hidden">
          <ArrowRightIcon />
        </div>

        <div className="flex flex-1 flex-col items-start gap-2 md:items-center">
          <Typography
            className="text-[20px] font-semibold md:text-[12px]"
            color="text.primary"
            variant="h6"
          >
            <FormattedMessage id="home.contactUs.description" />
          </Typography>
          <div className="flex gap-2">
            {supportLinks.map((link, index) => {
              if (isSmAndLower) {
                return (
                  <IconButton
                    // eslint-disable-next-line @eslint-react/no-array-index-key -- fixed support-link list, never reorders
                    key={index}
                    aria-label={link['aria-label'] || link.label}
                    component="a"
                    href={link.href}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {link.icon}
                  </IconButton>
                )
              }

              return (
                <Button
                  // eslint-disable-next-line @eslint-react/no-array-index-key -- fixed support-link list, never reorders
                  key={index}
                  aria-label={link['aria-label'] || link.label}
                  color="secondary"
                  href={link.href}
                  rel="noopener noreferrer"
                  size="small"
                  startIcon={link.icon}
                  target="_blank"
                  variant="text"
                >
                  {link.label}
                </Button>
              )
            })}
          </div>
        </div>
      </div>
    </Paper>
  )
}
